// extracted by mini-css-extract-plugin
export var heart = "like-button-module--heart--a1e51";
export var heartEmpty = "like-button-module--heart-empty--400f8";